import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";

import type { IAlertStore } from "@components/organisms/alert/types";
import { ALERT_DEFAULT_PROPS } from "@components/organisms/alert/config";

export const useAlertStore = create<IAlertStore>()(
  subscribeWithSelector(
    devtools((set) => ({
      alertProps: ALERT_DEFAULT_PROPS,
      setAlertProps: (data) => {
        set({ alertProps: data });
      },
      reset: () => {
        set({ alertProps: ALERT_DEFAULT_PROPS });
      },
    })),
  ),
);
